import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 19h12v2H6v-2z"
}), 'MinimizeTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MinimizeTwoTone.js
// module id = 4845
// module chunks = 2